import { gql } from '@apollo/client';

export const GET_VENDOR_LIST = gql`
  query GetVendorList($seasonId: String!) {
    season(id: $seasonId) {
      id
      signupForm {
        fields {
          id
          type
          definition
        }
      }
      vendors {
        id
        name
        contact
        email
        category
        status
        balance
        tags {
          id
        }
        markets {
          id
          dates
        }
        textFields {
          fieldId
          name
          value
        }
        createdAt
        updatedAt
      }
      markets {
        id
        name
        description
        dates
        numSpots
        hidden
        createdAt
        updatedAt
      }
      tags {
        id
        name
        color
      }
      vendorCategories
    }
  }
`;

export const VENDOR_BULK_DELETE = gql`
  mutation VendorBulkDelete($ids: [String!]!) {
    vendorBulkDelete(ids: $ids) {
      result
      recordsAffected
    }
  }
`;

export const VENDOR_BULK_UPDATE = gql`
  mutation VendorBulkUpdate($ids: [String!]!, $updates: VendorBulkUpdates!) {
    vendorBulkUpdate(ids: $ids, updates: $updates) {
      result
      recordsAffected
    }
  }
`;
